module.exports = __webpack_public_path__ + "static/media/math-arena-case-study-cover.7f0b8eb6.png";